module.exports = __webpack_public_path__ + "img/va.67b17091.svg";